/// <amd-module name="SuiteCommerce.Blog.DataProvider.File.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.DataProvider.File.Collection", ["require", "exports", "Backbone", "SuiteCommerce.Blog.DataProvider.File.Model", "Utils"], function (require, exports, Backbone_1, DataProvider_File_Model_1, Utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FileCollection = void 0;
    var FileCollection = /** @class */ (function (_super) {
        __extends(FileCollection, _super);
        function FileCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.model = DataProvider_File_Model_1.FileModel;
            _this.url = Utils.getAbsoluteUrl(getExtensionAssetsPath('assets/services/BlogFileDataSearch.Service.ss'), true);
            return _this;
        }
        FileCollection.prototype.getFileById = function (id) {
            return this.find(function (file) {
                return file.id === id;
            });
        };
        return FileCollection;
    }(Backbone_1.Collection));
    exports.FileCollection = FileCollection;
});
